<template>
  <b-container>
    <b-card v-if="appointmentId===null">
      <h4>Schedule a new appointment</h4>
      <b-breadcrumb>
        <b-breadcrumb-item :to="{name: 'appointment-list', params: { wardId: wardId}}">Back to Appointments</b-breadcrumb-item>
        <b-breadcrumb-item active>New Appointment</b-breadcrumb-item>
      </b-breadcrumb>
    </b-card>
    <b-card v-if="appointmentId!==null">
      <b-breadcrumb>
        <b-breadcrumb-item :to="{name: 'appointment-list', params: { wardId: wardId}}">Back to Appointments</b-breadcrumb-item>
        <b-breadcrumb-item active>Modify appointment</b-breadcrumb-item>
      </b-breadcrumb>
      <h4>Status: <b-badge :variant="(appointment.appointment_state==='SCHEDULED')? 'success' : 'secondary'">{{appointment.appointment_state}}</b-badge> Appointment: {{flattenOutAttendees(appointment.attendee_contacts)}}</h4>

    </b-card>
    <b-card>
      <b-form @submit="onSubmit">
        <b-form-row>
          <b-col>
              <b-form-group
                  id="input-group-2"
                  label="Appointment Reason:"
                  label-for="input-2"
                  description="The reason for the appointment being requested.">
                  <b-form-select
                      id="input-2"
                      v-model="appointment.appointment_type"
                      :options="appointmentTypeOptions"
                      required
                  ></b-form-select>
              </b-form-group>
          </b-col>
          <b-col v-if="showOtherReason">
            <b-form-group
              id="input-group-33"
              label="Other Reason Description"
              label-for="input-3"
              description="Additional Description for the appointment"
            >
              <b-form-input
                id="input-33"
                v-model="appointment.appointment_other_reason"
                type="text"
                placeholder="This is the reason that will be sent on the reminder">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
                <b-form-group
                    id="input-group-1"
                    label="Appointment Date"
                    label-for="input-1"
                    description="The date of the appointment"
                    >
        <VueCtkDateTimePicker
            id="input-group-1"
            label="Appointment Date"
            format="YYYY-MM-DDTHH:mm:ssZ"
            formatted="LLLL"
            :minuteInterval="appointment.minutes_duration"
            :minDate="scheduleOnlyFuture"
            v-model="appointment.appointment_date"/>
                </b-form-group>
            </b-col>
          <b-col>
            <b-form-group
              id="input-group-33"
              label="Appointment Location"
              label-for="input-33"
              description="Where will the appointment take pleace"
            >
            <b-form-select
                id="input-33"
                v-model="appointment.appointment_location"
                :options="appointmentLocationsOptions"
                @change="changeIntervalOnType"
            ></b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-group
              id="input-group-duration"
              label="Appointment Duration (minutes):"
              label-for="input-duration"
              description="The length of the appointment in minutes"
            >
              <b-form-spinbutton
                id="input-duration"
                v-model="appointment.minutes_duration"
                min="5"
                max="60"
                step="5"
              ></b-form-spinbutton>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-group
              id="input-group-3"
              label="Send Reminder before appointment:"
              label-for="input-3"
              description="Send Reminder before appointment. Value of 0 means no reminder will be sent"
            >
            <b-form-row>

              <b-col>
                <b-form-spinbutton
                  id="demo-sb"
                  v-model="appointment.interval_value"
                  min="0"
                  :max="intervalMax"
                  :step="intervalStep"
                ></b-form-spinbutton>
                </b-col>
              <b-col>
            <b-form-select
                id="input-2"
                v-model="appointment.interval_type"
                :options="appointmentIntervalOptions"
                @change="changeIntervalOnType"
            ></b-form-select>
                </b-col>
            </b-form-row>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-group
            id="input-group-4"
            label="Organizer:"
            label-for="input-4"
            description="Search for the person to request the appointment with"
            >
              <v-multiselect
                id="input-4-new"
                v-model="appointment.organizing_contact"
                :options="searchResults"
                :custom-label="contactPrettyDisplay"
                placeholder="Type to search ward contacts"
                label="full_name"
                track-by="contact_id"
                :internal-search="false"
                :show-no-results="true"
                :loading="isLoading"
                :showNoOptions="false"
                @search-change="searchContacts"
                @open="clearSearchResults"

              >
                <span slot="noResult">Oops! No contacts found!.</span>
              </v-multiselect>
            </b-form-group>
          </b-col>

        </b-form-row>
        <b-form-row>
          <b-col>
            <b-card>
              <h5 v-if="appointment.organizing_contact === null" class="text-muted">Public Appointment (No Organizer)</h5>
              <h5 v-if="appointment.organizing_contact !== null">Organizer: {{(appointment.organizing_contact.title!==null)?appointment.organizing_contact.title+" ":""}}{{appointment.organizing_contact.full_name}}</h5>
              {{(appointment.organizing_contact !== null)?"Tel No: " + appointment.organizing_contact.phone_number:""}}
            </b-card>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-group
            id="input-group-5"
            label="Attendees:"
            label-for="input-5"
            description="Search for the person that requested the appointment"
            >
              <v-multiselect
                id="input-4-new"
                v-model="appointment.attendee_contacts"
                :options="searchResults"
                :custom-label="contactPrettyDisplay"
                placeholder="Type to search ward contacts"
                label="full_name"
                track-by="contact_id"
                :internal-search="false"
                :show-no-results="true"
                :showNoOptions="false"
                :loading="isLoading"
                :multiple="true"
                @search-change="searchContacts"
                @open="clearSearchResults"

              >
                <span slot="noResult">Oops! No contacts found!.</span>
              </v-multiselect>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row v-if="appointment.attendee_contacts.length > 0">
          <b-col >
            <b-card >
              <h5 v-if="appointment.attendee_contacts.length === 0">No Attendees Selected.</h5>
              <h5 v-if="appointment.attendee_contacts.length > 0">Attendees Selected.</h5>
              <b-table v-if="appointment.attendee_contacts.length>0" striped hover :items="appointment.attendee_contacts" :fields="attendeeFields"></b-table>
            </b-card>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-group
              id="input-group-3"
              label="Comments"
              label-for="input-3"
              description="Any comments regarding the appointment"
            >
              <b-form-input
                id="input-3"
                v-model="appointment.comments"
                type="text"
                placeholder="Enter any comments that need to be conveyed">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-button type="submit" variant="primary" ref="wardScheduleAppointmentFormSubmit" v-if="appointmentId!==null">Update</b-button>
            <b-button type="submit" variant="primary" v-if="appointmentId===null">Schedule</b-button>
          </b-col>
          <b-col align-self="center" v-if="appointmentId!==null">
            <b-button variant="success" @click="markAppointmentComplete">Mark Complete</b-button>
          </b-col>
          <b-col>
            <b-button class="float-right" variant="danger" v-if="appointmentId!==null" v-on:click="deleteAppointment">Delete  <font-awesome-icon icon="trash" /></b-button>
          </b-col>
        </b-form-row>
    <b-form-row>
        <b-col>
  <b-tabs class="mt-3" content-class="mt-3" v-if="appointmentId!==null" >
    <b-tab title="Events" active><AppointmentEventList v-if="appointmentId!==null" :wardId="wardId" :appointmentId="appointmentId"/>  </b-tab>
  </b-tabs>
    </b-col>
    </b-form-row>
      </b-form>
    </b-card>
  </b-container>
</template>
<script>
import { AppointmentApi } from "@/app/appointments/appointmentApi";
import { WardApi } from "@/app/wards/wardApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
import AppointmentEventList from "@/app/appointments/AppointmentEvents";
import _ from 'lodash'

export default {
  name: "AppointmentDetail",
  props: {
    wardId: {
      type: String,
      required: true,
    },
    appointmentId: {
      type: String,
      required: false,
      default: null
    }
  },
  components: {AppointmentEventList},
  mixins: [userMixin],
  data () {
    return {
      appointment: {
        appointment_date: null,
        minutes_duration: 15,
        comments: null,
        attendee_contacts: [],
        organizing_contact: null,
        appointment_type: null,
        appointment_state: "PENDING",
        ward_id: null,
        interval_value: 1,
        interval_type: "days",
        appointment_other_reason: null,
        appointment_location: "church building"
      },
      intervalMax: 0,
      intervalStep: 20,
      organizerSearchTerm: null,
      attendeeSearchTerm: null,
      appointmentTypeOptions: [],
      appointmentStateOptions: [],
      appointmentIntervalOptions: [],
      appointmentLocationsOptions: [],
      searchResults: [],
      tempOrganizingContact: null,
      tempAttendeeContacts: [],
      isLoading: false,
      wardAppointmentDefaults: null,
      attendeeFields: [
        {
          key: "full_name",
          label: "Full name",
        },
        {
          key: "phone_number",
          label: "Tel No."
        }
      ]
    }
  },
  computed: {
    scheduleOnlyFuture() {
      if (this.appointmentId !== null || this.appointmentId !== undefined)
        return;
      let m = this.$moment();
      return m.format().replace("T", " ").slice(0, -6);
    },
    showOtherReason() {
      return this.appointment.appointment_type === "OTHER";
    }
  },
  watch: {
    'appointment.appointment_type': function(newType, oldType) {
      // Auto-populate duration when appointment type changes
      if (newType && this.wardAppointmentDefaults) {
        const defaults = this.wardAppointmentDefaults[newType];
        if (defaults && defaults.appointment_lengths && defaults.appointment_lengths[newType]) {
          this.appointment.minutes_duration = defaults.appointment_lengths[newType];
        }
      }
    }
  },
  async mounted() {
    // Fetch ward configuration for appointment length defaults
    try {
      const { data } = await WardApi.getWardDetail(this.wardId);
      this.wardAppointmentDefaults = data.public_appointments_defaults || {};
    } catch (e) {
      console.warn("Could not fetch ward appointment defaults:", e);
      this.wardAppointmentDefaults = {};
    }
    
    if(this.appointmentId) {
      this.appointment = await this.getAppointment();
      this.make_appointment_pretty();
    }
    this.changeIntervalOnType(this.appointment.interval_type, false);
    this.appointmentTypeOptions = this.$store.state.frontEndSettings.ward_appointment_types;
    this.appointmentStateOptions = this.$store.state.frontEndSettings.appointment_states;
    this.appointmentIntervalOptions = this.$store.state.frontEndSettings.appointment_intervals;
    this.appointmentLocationsOptions = this.$store.state.frontEndSettings.ward_appointment_locations;

  },
  methods: {
    clearSearchResults(){
      this.searchResults = []
    },
    contactPrettyDisplay(item){
      return `${item.first_name} ${item.last_name} (${item.phone_number})`;

    },
    async getAppointment() {
      try {
        const { data } = await AppointmentApi.getAppointmentDetail(this.wardId, this.appointmentId);
        // massage the data
        return data;
      } catch (e) {
        handleError(e, "Error trying to fetch appointment details");
      }
    },
    make_appointment_pretty() {
      // full name org contact (only if organizing_contact exists - public appointments don't have one)
      if (this.appointment.organizing_contact) {
        this.appointment.organizing_contact.full_name = `${this.appointment.organizing_contact.first_name} ${this.appointment.organizing_contact.last_name}`;
      }

      // full name attendee contact
      if (this.appointment.attendee_contacts) {
        this.appointment.attendee_contacts.forEach( item => {
          item.full_name = `${item.first_name} ${item.last_name}`;
        });
      }
    },
    markAppointmentComplete() {
      this.appointment.appointment_state = "EXPIRED";
      this.$refs.wardScheduleAppointmentFormSubmit.click();
    },
    async onSubmit(event) {
      event.preventDefault();
      try {
        if (this.appointmentId!==null) {
          // prep some model partition information
          this.appointment.appointment_id = this.appointmentId;
          this.appointment.ward_id = this.wardId;

          //now send over the wire
          const {data} = await AppointmentApi.updateAppointmentDetail(this.wardId, this.appointmentId, this.appointment);
          this.$toast.success("Updated appointment successfully");
          await this.$router.push({name: 'appointment-list', params: {wardId: this.wardId}});
        } else {
          this.appointment.ward_id = this.wardId;
          const { data } = await AppointmentApi.createAppointment(this.wardId, this.appointment);
          this.appointment = data;
          this.$toast.success("Created appointment successfully");
          await this.$router.push({name: 'appointment-list', params: {wardId: this.wardId}});
        }
      } catch (e) {
        console.log(e)
        if (e.response.status === 409) {
          handleError(e, "Error: Appointment Conflict");
        } else {
          handleError(e, "Error trying to process appointment details request");
        }
      }
    },
    async deleteAppointment() {
      try {
        const { data } = await AppointmentApi.deleteAppointment(this.wardId, this.appointmentId);
        this.$toast.success("Successfully cancelled appointment");
        await this.$router.push({name: 'appointment-list', params: {wardId: this.wardId}});
      } catch (e) {
        handleError(e, "Error trying to process Appointment Request");
      }
    },
    searchContacts: _.debounce(async function(term) {
      if (term===null || term===""){
        return
      }

      let payload = {
                aux_id : null,
                pk_id : null,
                gsi_pk: null,
                gsi_sk: null,
                org_filter: "WARD",
                search_term: term
            }
      this.isLoading = true;
      const { data } = await WardApi.getWardList(this.wardId, payload);
      this.convertToLightContact(data.contact_list);
      this.isLoading = false;

    }, 500),
  convertToLightContact(contact_list) {
    this.searchResults = [];
    contact_list.forEach(item => {
      let lightContact = {
        full_name: `${item.first_name} ${item.last_name}`,
        first_name: item.first_name,
        last_name: item.last_name,
        title: item.title,
        contact_id: item.contact_id,
        phone_number: item.phone_number,
        send_through_whatsapp: item.send_through_whatsapp,
      }
      this.searchResults.push(lightContact);
    })
  },
    flattenOutAttendees(attendees) {
      let out_response = []
      attendees.forEach((attendee) => {
        out_response.push(`${attendee.first_name} ${attendee.last_name}`);
      })
      return out_response.join(', ');
    },
    changeIntervalOnType(val, shouldReset=true) {
      if (shouldReset) {
        this.appointment.interval_value = 0;
      }
      if (val === "minutes") {
        this.intervalMax = 60;
        this.intervalStep = 5;
      }

      if (val === "hours") {
        this.intervalMax = 24;
        this.intervalStep = 1;
      }

      if (val === "days") {
        this.intervalStep = 1;
        this.intervalMax = 3;
      }
    }

  },

}

</script>
